import { ReactComponent as controlled_prescription } from '~/assets/icons/controlled_prescription.svg';
import { ReactComponent as download } from '~/assets/icons/download.svg';
import { ReactComponent as exam } from '~/assets/icons/exam.svg';
import { ReactComponent as anatomy_exam } from '~/assets/icons/exame-anatomia.svg';
import { ReactComponent as image_exam } from '~/assets/icons/exame-imagem.svg';
import { ReactComponent as laboratory_exam } from '~/assets/icons/exame-laboratorial.svg';
import { ReactComponent as other_exam } from '~/assets/icons/exame-outros.svg';
import { ReactComponent as lock } from '~/assets/icons/lock.svg';
import { ReactComponent as next } from '~/assets/icons/next.svg';
import { ReactComponent as other_documents } from '~/assets/icons/other_documents.svg';
import { ReactComponent as prescription } from '~/assets/icons/prescription.svg';
import { ReactComponent as report } from '~/assets/icons/report.svg';
import { ReactComponent as sick_note } from '~/assets/icons/sick_note.svg';
import { ReactComponent as share_info } from '~/assets/icons/share_info_icon.svg';
import { ReactComponent as whatsapp } from '~/assets/icons/whatsapp.svg';

export default {
  prescription,
  exam,
  anatomy_exam,
  image_exam,
  laboratory_exam,
  other_exam,
  sick_note,
  report,
  other_documents,
  controlled_prescription,
  lock,
  download,
  next,
  share_info,
  whatsapp,
};
